<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Almanorte SPA | Sistema Garita V1.0.0</p>
    </div>
  </div>
</div>